import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import initI18next from './core/i18n/scripts/init';
import { setupInstrumentation } from './core/monitoring/instrument';

import './visual-components/styles/globals.scss';

setupInstrumentation();
initI18next();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
